var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container__messagecontainer"},_vm._l((_vm.messages),function(message,key){return _c('Message',{key:key,attrs:{"message-id":message.messageId,"message-title":message.messageTitle,"message-list":message.messageList,"message-text":message.messageText,"message-icon":message.messageIcon,"message-type":message.messageType}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }